import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { RequestsBankOpsCreate } from './RequestsBankOpsCreate/RequestsBankOpsCreate';
import { RequestsBankOpsEdit } from './RequestsBankOpsEdit/RequestsBankOpsEdit';
import { RequestsBankOpsList } from './RequestsBankOpsList/RequestsBankOpsList';
import { RequestsBankOpsShow } from './RequestsBankOpsShow/RequestsBankOpsShow';

export const requestsBankOpsResource: ResourceProps = {
  name: Resources.RequestBankOperations,
  list: RequestsBankOpsList,
  create: RequestsBankOpsCreate,
  edit: RequestsBankOpsEdit,
  show: RequestsBankOpsShow,
};
